import { Model } from '@vuex-orm/core'
import Project from '@models/project/Project';

export default class Configuration extends Model{
  static entity = 'configurations'
  static fields () {
    return {
      id: this.attr(null),
      service_id: this.attr(null).nullable(),
      description: this.attr(null).nullable(),
      editor: this.attr(null).nullable(),
      project_id: this.attr(null).nullable(),
      status: this.attr(null).nullable(),
      version: this.attr(null).nullable(),
      norms_id: this.attr(1).nullable(),
      formula_version: this.attr(2).nullable(),
      note: this.attr(null).nullable(),

      selectedConfiguration: this.boolean(false),
      isUseraccess: this.boolean(false),
      project: this.belongsTo(Project, 'project_id'),
    }
  }
}
  